import ScratchCard from "./Components/scratchCard.js";
import TeamRecord from "./Components/TeamRecord.js";
import { useLoaderData, useParams, useSearchParams } from "react-router-dom";
import RemoveCanvasButton from "./Components/RemoveCanvasButton";
import VoteButton from "./Components/VoteButton.js";
import DateBrowser from "./Components/DateBrowser.js";
const NBAHomePage = () => {

    const data = useLoaderData();
    const gameData = data.internalData;
    const sport = "NBA";

    const { date } = useParams();


    const [searchParams]= useSearchParams();
    const timezone = searchParams.get('tz') ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

    //insert sorting logic
    //how should this look? LiveGames are the first in the array, Ended games are in the bottom
    //if no games are live, then evaluate by start time
    //that critical variables are startTimestamp and statusType
    //how would this look like? grab the array
    //  for game in data.externalData>> game.startTimeStamp, game.statusType
    // what do we want to do with these guys? we need to ask some questions, so we say is game.statusType live? 
    //maybe not...we need a new object that holds the order.. like an object that says 
    
const statusOrder = {
  "inprogress" : 0,
  "notstarted" : 1,
  "finished": 2
};
const sortedData = [...data.externalData].sort((a, b)=>{
  if (a.statusType !== b.statusType){
    return statusOrder[a.statusType] - statusOrder[b.statusType];
  }
  return a.startTimestamp - b.startTimestamp
});

console.log(sortedData);


    return (
    <>
    <div className="sports-page">
      <h1>National Basketball Association Scoreboard</h1>
      <DateBrowser date={date} sport={sport} timezone={timezone}/>
      <RemoveCanvasButton />
      {data.message && <h2>{data.message}</h2>}
      {sortedData.map(
        ({  id, tournamentName, awayTeam, awayScore, homeTeam, homeScore, startTimestamp, status, statusType, homeRecord, awayRecord, venue, 
           roundName, roundGame, homeTeamSeriesRecord, awayTeamSeriesRecord, homeTeamSeed, awayTeamSeed,
        }) => {

          const gameVotes = gameData.find(vote => vote.eventID === id);

          const watchWorthyScore = (Math.abs(awayScore - homeScore) <=4 && (awayScore + homeScore) >=200)? 1 : 0 ;
          console.log(watchWorthyScore);

          const borderStyles ={
            "finished": "border-red",
            "inprogress": "border-green"
          }


          return (
            <div className="game-grid">
            <section key={id} className={`game-container ${borderStyles[statusType] ?? ""}`}>
               <div className="teams-row">
                <TeamRecord sport={sport} teamName={awayTeam} record={awayRecord} opponentRecord={homeRecord} seriesRecord={awayTeamSeriesRecord} opponentSeriesRecord={homeTeamSeriesRecord} tournamentName={tournamentName} className={"away-team"} />
                <h1>@</h1>
                <TeamRecord sport={sport} teamName={homeTeam} record={homeRecord} opponentRecord={awayRecord} seriesRecord={homeTeamSeriesRecord} opponentSeriesRecord={awayTeamSeriesRecord} tournamentName={tournamentName} className={"home-team"} />
              </div>
              <h3>{tournamentName === "NBA, Playoffs" && roundName}</h3>
              <h3>Game: {roundGame}</h3>

              <h3>Start Time: {new Date(startTimestamp*1000).toLocaleTimeString([], { hour: "numeric", minute: "numeric"})} {venue}</h3>
              <h3>{status==="AET" ? "Overtime" : status  }</h3>

                      <div className="grid-container">
                  
                        <VoteButton eventID={id} sport={sport} gameDate={date} gameVotes={{upvotes: gameVotes?.upvotes || 0, downvotes: gameVotes?.downvotes || 0}} className="element-1"/>
                        <div className="scores-section element-2">
                            <ul className="scratchable">
                              <li>
                                <span>{awayTeam}:</span> 
                                <ScratchCard text={awayScore} watchWorthyScore={watchWorthyScore} />
                              </li>
                    
                              <li>
                                <span>{homeTeam}:</span>
                                <ScratchCard text={homeScore} watchWorthyScore={watchWorthyScore} />
                              </li>
                            </ul>
                          </div>
                          <div className="watchworthy element-3">

                          </div>

                      </div>
            </section>
          </div>
        )}
      )}
     </div> 
    </>
  );
};

export default NBAHomePage;